module.exports = __webpack_public_path__ + "img/3.280cf64f.png";